export const FUNDAYLIST_URL = "fundaylist.com";
export const FUNDAYLIST = "fundaylist";
export const LOCALHOST = "localhost";
export const LOADING = "loading";
export const GRANTED = "granted";
export const DENIED = "denied";
export const PROMPT = "prompt";
export const YOU = "you";
export const DOWNTOWN = "downtown";

export enum ListingType {
  PLACE = "place",
  RESTAURANT = "restaurant",
  BAR = "bar",
  EVENT = "event",
  ACTIVITY = "activity",
}

export enum ListingSource {
  OPENTABLE = "opentable",
  VIATOR = "viator",
  GOOGLE = "google",
  PERSON = "person",
  DONETWORK = "donetwork",
  TICKETMASTER = "ticketmaster",
  FACEBOOK = "facebook",
}
export enum InterestTags {
  AMERICAN_FOOD = "american_food",
  AFRICAN_FOOD = "african_food",
  ART = "art",
  ASIAN_FOOD = "asian_food",
  BEER = "beer",
  BRUNCH = "brunch",
  CAFE = "cafe",
  CARIBBEAN_FOOD = "caribbean_food",
  CENTRAL_AMERICAN_FOOD = "central_american_food",
  CHINESE_FOOD = "chinese_food",
  CLUBS = "clubs",
  COCKTAILS = "cocktails",
  COFFEE = "coffee",
  COMEDY = "comedy",
  COUNTRY_MUSIC = "country_music",
  DANCING = "dancing",
  DIVE_BAR = "dive_bars",
  EUROPEAN_FOOD = "european_food",
  GAMES = "games",
  HEALTHY_FOOD = "healthy_food",
  INDIAN_FOOD = "indian_food",
  ITALIAN_FOOD = "italian_food",
  KARAOKE = "karaoke",
  LATIN_MUSIC = "latin_music",
  LIVE_MUSIC = "live_music",
  MEDITERRANEAN_FOOD = "mediterranean_food",
  MEXICAN_FOOD = "mexican_food",
  MIDDLE_EASTERN_FOOD = "middle_eastern_food",
  MOVIES_THEATER = "movies_theater",
  NATURE_OUTDOORS = "nature_outdoors",
  OTHER_FUN = "other_fun",
  ROCK_MUSIC = "rock_music",
  SEAFOOD = "seafood",
  SOUTH_AMERICAN_FOOD = "south_american_food",
  SPORTS = "sports",
  SWEETS = "sweets",
  VEGETARIAN_FOOD = "vegetarian_food",
  VEGAN_FOOD = "vegan_food",
  WINE = "wine",
}

export enum CrowdTags {
  COLLEGE = "college",
  DOG_FRIENDLY = "dog_friendly",
  KID_FRIENDLY = "kid_friendly",
  LGBTQ = "lgbtq",
}
export enum PriceTags {
  FREE = "free",
  CASH_1 = "cash_1",
  CASH_2 = "cash_2",
  CASH_3 = "cash_3",
}
export interface ImageI {
  alt?: string;
  src: string;
  is_cropped: string;
  is_fun: string;
}
export interface RegionI {
  border_coordinates: BorderCoordinatesI[];
  name: string;
}

export interface BorderCoordinatesI {
  lat: number;
  long: number;
}
export interface IconI {
  className?: string;
  fill?: string;
}
export interface AffiliateI {
  affiliate_id?: number;
  commission?: number;
  content_url?: string;
  created_time?: string;
  referral_id?: string;
  source?: ListingSource;
  updated_time?: string;
  url: string;
}
export interface GeolocationI {
  geoCenter: string;
  radius: number;
  latitude: string;
  longitude: string;
}
export interface LikedListingI {
  id: string;
  type: string;
  subtype: string;
  title: string;
  date: string;
  img_src: string;
}

export interface AppI {
  city: CityI | undefined;
  modal: string;
  pathname: string;
  scrollY: number;
  calendar: {
    dates: Date[];
  };
  menu: {
    isCalendarActive: boolean;
    isMainMenuActive: boolean;
    isFilterMenuActive: boolean;
    isLikeMenuActive: boolean;
    isSearchActive: boolean;
    isBackButtonActive: boolean;
    isInterestMenuActive: boolean;
  };
  configure: { filters: string };
  refinementList: {
    type: string[];
    interest_tags: string[];
    crowd_tags: string[];
    price_tags: string[];
    [key: string]: string[] | undefined;
  };
  query: string;
  geolocation: GeolocationI;
}

export interface UserI {
  email: string;
  firstName: string;
  isAdmin: boolean;
  isLoggedIn: boolean;
  likedListings: LikedListingI[];
  lastName: string;
  role: string;
  geolocation: {
    longitude: string;
    latitude: string;
  };
}

export interface CityI {
  collection: string;
  coordinates: { lat: number; long: number };
  country: string;
  facebook_url: string;
  ga_id: string;
  images: ImageI[];
  instagram_url: string;
  name: string;
  regions: RegionI[];
  state: string;
  tagline: string;
  tiktok_url: string;
  timezone: string;
}
export interface PlaceI {
  address: string;
  description: string;
  html: string;
  images: ImageI[];
  place_id: number;
  subtype: string;
  title: string;
  website_url?: string;
}
export interface ActivityI {
  address: string;
  affiliate?: AffiliateI;
  description: string;
  html: string;
  images: ImageI[];
  subtype: string;
  title: string;
}
export interface EventI {
  address: string;
  affiliate?: AffiliateI;
  description: string;
  end_time: string;
  html: string;
  images: ImageI[];
  start_time: string;
  subtype: string;
  title: string;
}
export interface ListingI {
  active_start_time_unix?: number;
  active_start_time?: string;
  active_end_time_unix?: number;
  active_end_time?: string;
  activity?: ActivityI | null;
  address?: string;
  city_region?: string[];
  crowd_tags?: string[];
  description?: string;
  event?: EventI | null;
  google_address?: string;
  html?: string;
  id?: string;
  images?: ImageI[];
  interest_tags?: string[];
  keywords?: string[];
  listing_id?: number;
  location?: number[];
  open_hours?: {
    [key: string]: string;
  };
  place?: PlaceI;
  price_tags?: string[];
  ranking?: number;
  rating?: number;
  subtype?: string;
  timezone?: string;
  title?: string;
  type?: string;
  unique_type?: string;
}
